































































import AppLayout from '@tool/Layouts/AppLayout.vue'
import Breadcrumbs from "@tool/Components/Breadcrumbs.vue";
import {defineComponent, PropType} from "@vue/composition-api";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import {formatNumber, formatPrice} from "@tool/Pages/App/Teams/Billing/billing.helpers";
import AffiliateInfoCard from "@tool/Pages/App/Affiliate/partials/AffiliateInfoCard.vue";
import CopyInputGroup from "@base/Components/CopyInputGroup.vue";
import SharingButtons from "@tool/Components/SharingButtons.vue";

interface AffiliateStats {
    referrals: { visitors: number; conversions: number; leads: number };
    commissions: { total: number; dueNow: number; pending: number; paid: number };
}

export default defineComponent({
    components: {
        Breadcrumbs,
        AppLayout,
        AffiliateInfoCard,
        ThemeBlock,
        CopyInputGroup,
        SharingButtons
    },

    props: {
        affiliate_id: {
            type: String,
            required: true
        },
        stats: {
            type: Object as PropType<AffiliateStats>,
            required: true
        }
    },

    setup(props) {
        const affiliateUrl = `https://utmtool.com/?ref=${props.affiliate_id}`;

        return {
            affiliateUrl,
            formatNumber,
            formatPrice
        }
    }
})
